import { createAction, props } from '@ngrx/store';
import { NotificationItems } from './notification.model';

export const loadNotifications = createAction(
  '[Notification List] Load Notifications',
  props<{ prfyear: number; groupcode: string }>()
);

export const loadNotificationsSuccess = createAction(
  '[Notification List] Load Notifications Success',
  props<{
    items: NotificationItems;
  }>()
);

export const loadNotificationsFailure = createAction(
  '[Notification List] Load Notifications Failure',
  props<{
    items: {};
  }>()
);

export const reset = createAction('[Notification List] Reset');